/**
 * Gera um slug a partir de um texto
 * Remove acentos, converte para minúsculas e substitui espaços por hífens
 */
export const generateSlug = (text: string): string => {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // Remove caracteres especiais
    .replace(/\s+/g, '-') // Substitui espaços por hífens
    .replace(/-+/g, '-') // Remove hífens duplicados
    .replace(/^-+|-+$/g, ''); // Remove hífens do início e fim
};

/**
 * Encontra um item pela slug comparando com o título
 */
export const findBySlug = <T extends { title: string }>(
  items: T[],
  slug: string
): T | undefined => {
  return items.find(item => generateSlug(item.title) === slug);
};

const TYPE_TO_CATEGORIA: Record<string, string> = {
  'Coletas': 'coletas',
  'Documentação': 'documentos',
  'Financeiro': 'financeiro',
  'Usuários e permissões': 'conta-e-acesso',
  'Dados': 'dados',
  'Geral': 'geral',
};

export const getCategoriaSlug = (type: string | null): string | null =>
  type ? (TYPE_TO_CATEGORIA[type] ?? null) : null;

export const buildArticleShareUrl = (title: string, type: string | null): string => {
  const slug = generateSlug(title);
  const categoria = getCategoriaSlug(type);
  if (categoria) {
    return `${window.location.origin}/ajuda/${categoria}?artigo=${slug}`;
  }
  return `${window.location.origin}/perguntasfrequentes/live/${slug}`;
};
